'use client';

import { useScrollDetection } from '@/hooks/useScrollDetection';

/**
 * ScrollTracker — Client-side component to track when a section comes into view
 *
 * Usage:
 *   <section>
 *     <ScrollTracker sectionName="features" />
 *     Content here
 *   </section>
 */
export function ScrollTracker({ sectionName, threshold = 0.5, params = {} }) {
    const ref = useScrollDetection(sectionName, {
        threshold,
        analyticsParams: params,
    });
    return <div ref={ref} className="hidden" aria-hidden="true" />;
}

export default ScrollTracker;
